import './offer-content.scss';
